import React from "react";
import { motion } from "framer-motion";

const About = () => {
  const calculateExperience = () => {
    const startDate = new Date("2018-06-01");
    const currentDate = new Date();
    const diffInYears =
      (currentDate.getTime() - startDate.getTime()) /
      (1000 * 3600 * 24 * 365.25);
    return Math.floor(diffInYears);
  };

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          About Me
        </motion.h2>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p>
              I'm a dedicated software engineer with over{" "}
              <span id="years-experience-about">{calculateExperience()}</span>{" "}
              years of experience in web development, currently working as a
              Senior Software Engineer & Team Lead at Ringkas. I'm passionate
              about creating efficient, scalable solutions and leading teams to
              deliver exceptional results.
            </p>
            <p>
              My expertise lies in modern web technologies including React,
              Node.js, and cloud platforms. I also specialize in AI and ML
              technologies, working with LangChain, LangSmith, LlamaIndex, and
              LlamaParse for document processing and AI advisory solutions. I
              believe in continuous learning and staying updated with the latest
              technologies to provide the best solutions for complex business
              challenges.
            </p>

            <div className="about-stats">
              <motion.div
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <div className="stat-number">{calculateExperience()}+</div>
                <div className="stat-label">Years Experience</div>
              </motion.div>
              <motion.div
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <div className="stat-number">50+</div>
                <div className="stat-label">Projects Completed</div>
              </motion.div>
              <motion.div
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
              >
                <div className="stat-number">6</div>
                <div className="stat-label">Team Members Led</div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="about-card">
              <div className="card-content">
                <h3>Quick Facts</h3>
                <ul>
                  <li>
                    <i className="fas fa-university"></i> Bach Khoa University -
                    Computer Science
                  </li>
                  <li>
                    <i className="fas fa-graduation-cap"></i> Self-taught
                    Developer
                  </li>
                  <li>
                    <i className="fas fa-code"></i> Full-stack Development
                  </li>
                  <li>
                    <i className="fas fa-users"></i> Team Leadership
                  </li>
                  <li>
                    <i className="fas fa-rocket"></i> Agile Methodologies
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
